import { jsx as _jsx } from "react/jsx-runtime";
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import { useScaleChecked } from '../../context/ScaleContext';
import { ResizerWithScale } from '../../elements/ResizerWithScale';
import { useHighlight } from '../../highlight';
import { useResizerStatus } from '../../hooks/useResizerStatus';
function BaseLineZones() {
    const { toolOptions: { selectedTool, data: { baselineCorrection }, }, } = useChartData();
    const baseLineZones = baselineCorrection.zones;
    if (selectedTool !== 'baselineCorrection' || baseLineZones.length === 0) {
        return null;
    }
    return (_jsx("g", { children: baselineCorrection.zones.map((zone) => (_jsx(BaseLineZone, { ...zone }, zone.id))) }));
}
function BaseLineZone(props) {
    const { from, to, id } = props;
    const { onHover, isActive, defaultActiveStyle: { backgroundColor: activeFill }, } = useHighlight([id], { type: 'BASELINE_ZONE', extra: { id } });
    const { scaleX } = useScaleChecked();
    const dispatch = useDispatch();
    function handleOnStopResizing(position) {
        dispatch({
            type: 'RESIZE_BASE_LINE_ZONE',
            payload: {
                id,
                from: scaleX().invert(position.x2),
                to: scaleX().invert(position.x1),
            },
        });
    }
    const isResizingActive = useResizerStatus('baselineCorrection');
    return (_jsx("g", { ...onHover, className: "base-line-zones", children: _jsx(ResizerWithScale, { from: from, to: to, onEnd: handleOnStopResizing, disabled: !isResizingActive, children: ({ x1, x2 }, isResizeActive) => {
                return (_jsx("rect", { width: Math.abs(x2 - x1), height: "100%", fill: isActive && !isResizeActive ? activeFill : '#b8b8b857' }));
            } }) }));
}
export default BaseLineZones;
